<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Turma</e-label>
                    <p class="font-weight-regular">
                      <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                        <v-select
                          :items="turmas"
                          :item-text="
                            (item) =>
                              item.turma?.descricao +
                              ' - [ ' +
                              item.turma?.franquia?.fantasia +
                              ' ]'
                          "
                          item-value="turma.id"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          @change="() => selecionaTurma()"
                          :error-messages="errors"
                        ></v-select>
                      </ValidationProvider>
                    </p>
                  </v-col>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-4 pb-0" cols="12">
                    <ValidationProvider name="Bimestre" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Bimestre</e-label>
                      <v-select
                        :items="bimestres"
                        :return-object="false"
                        @change="($event) => atualizarData($event)"
                        v-model="gestaoDeAula.bimestre_id"
                        :item-text="
                          (item) =>
                            item.status === 0
                              ? item.descricao
                              : `${item.descricao} (Bimestre Bloqueado)`
                        "
                        :item-value="(item) => item.id"
                        :item-disabled="(item) => item.status === 1"
                        label="Selecione um bimestre"
                        dense
                        solo
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </v-col>

                  <!-- <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Data</e-label>
                      <e-date-picker v-model="dataAulaDuplicada" :error-messages="errors" />
                    </ValidationProvider>
                  </v-col> -->

                  <v-col class="pt-0 pb-0" cols="12" sm="4">
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Selecione uma data</e-label>
                        <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                          <v-text-field
                            dense
                            solo
                            v-model="data_aula"
                            label="data"
                            v-bind="attrs"
                            v-on="on"
                            autocomplete="off"
                            :error-messages="errors"
                            readonly
                          ></v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-date-picker
                        color="primary"
                        v-model="dataAulaDuplicada"
                        scrollable
                        :min="bimestreSelecionado?.data_inicial"
                        :max="bimestreSelecionado?.data_final"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col class="pt-0 pb-0" v-if="!aulaRemota" cols="6">
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horarios"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        :disabled="!turmaSelecionada?.turma?.id"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <div>
                  <e-conteudo-aula-infantil v-if="aulaInfantil" :aula="gestaoDeAula" />
                  <e-conteudo-aula-regular v-else :aula="gestaoDeAula" />
                </div>

                <v-divider class="my-6"></v-divider>

                <!-- Verificador de conflitos -->
                <e-verificador-conflitos-aula
                  v-if="!aulaRemota"
                  :data="dataAulaDuplicada"
                  :horario-id="horarioSelecionado?.id"
                  :turma-id="turmaSelecionada?.turma?.id"
                  :e_aula_infantil="!!gestaoDeAula.e_aula_infantil"
                  :aula-id="null"
                  @conflitos-encontrados="temConflitos = $event"
                />

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperadosFiltrados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false), limparCampos()"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="faltaPreencher || !totalmentePreenchido || temConflitos"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
            <v-row v-if="validacao">
              <v-col cols="12" class="mt-4">
                <v-alert type="warning" border="left">
                  Por favor, preencha todos os campos!
                </v-alert>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
import EConteudoAulaInfantil from "./EConteudoAulaInfantil.vue";
import EConteudoAulaRegular from "./EConteudoAulaRegular.vue";

export default {
  components: { EConteudoAulaInfantil, EConteudoAulaRegular },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      date: null,
      bimestres: [],
      bimestreSelecionado: null,
      gestaoDeAulaId: null,
      dataAulaDuplicada: null,
      modal: false,
      menu: false,
      gestaoDeAula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {},
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      validacao: false,
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Bimestre", value: "gestaoDeAula.bimestre_id" },
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      temConflitos: false,
    };
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperadosFiltrados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  computed: {
    faltaPreencher() {
      return (
        !this.gestaoDeAula ||
        !this.gestaoDeAula.id ||
        !this.data_aula ||
        !this.horarioSelecionado ||
        !this.horarioSelecionado.id
      );
    },
    aulaInfantil() {
      return this.gestaoDeAula.e_aula_infantil === 1;
    },
    aulaRemota() {
      return this.gestaoDeAula?.tipo_de_aula === "Aula Remota";
    },
    itemsEsperadosFiltrados() {
      if (this.aulaRemota) {
        return this.itemsEsperados.filter((item) => item.value !== "horarioSelecionado");
      }
      return this.itemsEsperados;
    },
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
        this.gestaoDeAula.bimestre_id = null;
        this.loadBimestresDisponiveis();
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        // this.horarios = val.turma.horarios;
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );
            this.turmas = gestoes;
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(value) {
      if (!value) return;
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data_aula = data_old.replaceAll("/", "/");
    },
  },
  mounted() {
    // this.teste()
  },
  methods: {
    atualizarData(value) {
      this.bimestreSelecionado = this.bimestres.find((item) => item.id === value);
    },
    async loadBimestresDisponiveis() {
      const data = await this.$services.usuariosService.getBimestresDisponiveis();
      this.bimestres = data;
      this.bimestreSelecionado = this.bimestres.find(
        (item) => item.id === this.gestaoDeAula.bimestre_id
      );
    },
    selecionaTurma() {
      this.gestaoDeAulaId = this.turmaSelecionada.id;
      this.getHorarios();
    },
    async getHorarios() {
      const aulasDessaGestao = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.gestaoDeAulaId
      );
      this.horarios = aulasDessaGestao.payload.horarios;
    },
    enableSubmit() {
      if (!this.turmaSelecionada || !this.horarioSelecionado.id || !this.data_aula) {
        this.validacao = true;
      } else {
        this.validacao = false;
        this.confirmDialog = !this.confirmDialog;
        this.gestaoDeAula.data = this.dataAulaDuplicada;
      }
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        this.gestaoDeAula.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.gestaoDeAula.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;

        this.gestaoDeAula.horarios = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.gestaoDeAula.instrutorDisciplinaTurma_id = this.turmaSelecionada.id;
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        this.$emit("dialogChange", false);
        await this.$services.aulasService.criar(this.gestaoDeAula);

        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    limparCampos() {
      this.data_aula = null;
      this.turmaSelecionada = null;
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = null;
      this.totalmentePreenchido = false;
      this.temConflitos = false;
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
  },
};
</script>
